// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  API_URL: 'https://api.xirocco.io/',
  // API_URL: 'http://localhost:3000/',
  S3_API_URL: 'https://s3.eu-west-2.amazonaws.com/xirocco.com/',
  CRYPTO_SECRET: 'sr7l5JIPkILov1h1FvYakF0f'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.